import React, { useState } from "react";
import { useSelector } from "react-redux";
import Main from "./Main";
import MySidebar from "./Sidebar";

function Layout() {
  const [toggled, setToggled] = useState(false);
  const impersonated = useSelector(
    (state) => state.userReducer.user?.response?.impersonated
  );
  const impersonatedBy = useSelector(
    (state) => state.userReducer.user?.response?.impersonatedBy
  );

  const handleToggleSidebar = () => {
    setToggled((prev) => {
      return !prev;
    });
  };

  return (
    <div className="isw-app">
      {impersonated === true && (
        <div className="isw-impersonation">
          You are viewing as the partner
          {impersonatedBy ? ` (admin: ${impersonatedBy})` : ""}
        </div>
      )}
      <MySidebar toggled={toggled} handleToggleSidebar={handleToggleSidebar} />
      <Main handleToggleSidebar={handleToggleSidebar} />
    </div>
  );
}

export default Layout;
